// components/ImagePreviewModal.jsx
import React from 'react';
import { Dialog } from 'primereact/dialog';

const ImagePreviewModal = ({ visible, onHide, imageUrl }) => {
  return (
    <Dialog header="Belge Görseli" visible={visible} style={{ width: '600px' }} modal onHide={onHide}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt="Belge"
          style={{ width: '100%', objectFit: 'contain', borderRadius: '8px' }}
        />
      ) : (
        <p>Görsel bulunamadı.</p>
      )}
    </Dialog>
  );
};

export default ImagePreviewModal;
